import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "account-select-dropdown__selected-option" }
const _hoisted_2 = { class: "account-select-dropdown__selected-option-content" }
const _hoisted_3 = { class: "account-select-dropdown__selected-option-category" }
const _hoisted_4 = { class: "account-select-dropdown__selected-option-name" }

import { computed, inject, ref } from 'vue';

import type BigNumber from '@exchange/helpers/bignumber';
import { accountService } from '@exchange/libs/account/service/src';
import { subaccountsService, SubaccountType } from '@exchange/libs/trading-accounts/service/src';
import { CONSTANTS } from '@exchange/libs/utils/constants/src';
import { currencyService } from '@exchange/libs/utils/currency/src';

import AccountTag from './components/AccountTag.vue';

type SubaccountsItem = {
  value: string;
  name: string;
  totalBalance: BigNumber;
  id: number;
  isMain: boolean;
  type: SubaccountType;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountSelectDropdown',
  props: {
  disabled: { type: Boolean, default: false },
},
  setup(__props) {



const { accountId, isSubaccountMain } = accountService;
const { defaultFiatCurrency, currencies } = currencyService;

const defaultPrecision = CONSTANTS.PRECISION.DEFAULT_FIAT;

const getAccountTypeLabel = (type: SubaccountType): string => {
  switch (type) {
    case SubaccountType.STANDARD:
      return 'Spot';
    case SubaccountType.INSTANT_TRADE:
      return 'Swap';
    case SubaccountType.SPOT:
      return 'Spot';
    case SubaccountType.FUTURES:
      return 'Futures';
    default:
      return type;
  }
};

const subaccountsList = computed<Array<SubaccountsItem>>(() =>
  subaccountsService.list.value.map((account, index) => ({
    value: account.accountId,
    name: account.name,
    totalBalance: account.getBalanceTotal(currencies.value).all,
    id: index,
    isMain: isSubaccountMain(account.accountId),
    type: account.type,
  })),
);

const balanceMasked = inject('balanceMasked', ref(false));

const chosenSubaccount = computed({
  get: () => subaccountsList.value.find((item) => item.value === accountId.value),
  set: (newValue) => {
    if (newValue) {
      subaccountsService.switchTo(newValue.value);
    }
  },
});

return (_ctx: any,_cache: any) => {
  const _component_ot_balance = _resolveComponent("ot-balance")!
  const _component_ot_lozenge = _resolveComponent("ot-lozenge")!
  const _component_x_list_item = _resolveComponent("x-list-item")!
  const _component_ot_select = _resolveComponent("ot-select")!

  return (_openBlock(), _createBlock(_component_ot_select, {
    value: chosenSubaccount.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((chosenSubaccount).value = $event)),
    class: "account-select-dropdown",
    label: "name",
    variant: "dark-outlined",
    "open-indicator-icon-name": "down",
    disabled: __props.disabled,
    options: subaccountsList.value
  }, {
    "selected-option": _withCtx((subaccount) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(subaccount.name), 1),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_ot_balance, {
              value: subaccount.totalBalance,
              precision: _unref(defaultPrecision),
              symbol: _unref(defaultFiatCurrency),
              masked: _unref(balanceMasked)
            }, null, 8, ["value", "precision", "symbol", "masked"])
          ])
        ]),
        _createVNode(_component_ot_lozenge, {
          text: getAccountTypeLabel(subaccount.type),
          class: "account-select-dropdown__type-lozenge account-select-dropdown__type-lozenge--selected",
          filled: false
        }, null, 8, ["text"])
      ])
    ]),
    option: _withCtx((subaccount) => [
      (subaccount.isMain)
        ? (_openBlock(), _createBlock(AccountTag, {
            key: 0,
            class: "account-select-dropdown__bullet",
            "is-main": true
          }))
        : (subaccount.id === 1)
          ? (_openBlock(), _createBlock(AccountTag, {
              key: 1,
              class: "account-select-dropdown__bullet",
              "is-main": false
            }))
          : _createCommentVNode("", true),
      _createVNode(_component_x_list_item, {
        class: "account-select-dropdown__option",
        title: subaccount.name,
        active: chosenSubaccount.value && chosenSubaccount.value.id === subaccount.id
      }, {
        subtitle: _withCtx(() => [
          _createVNode(_component_ot_balance, {
            value: subaccount.totalBalance,
            precision: _unref(defaultPrecision),
            symbol: _unref(defaultFiatCurrency),
            masked: _unref(balanceMasked)
          }, null, 8, ["value", "precision", "symbol", "masked"])
        ]),
        "label-additional-content": _withCtx(() => [
          _createVNode(_component_ot_lozenge, {
            text: getAccountTypeLabel(subaccount.type),
            class: "account-select-dropdown__type-lozenge",
            filled: false
          }, null, 8, ["text"])
        ]),
        _: 2
      }, 1032, ["title", "active"])
    ]),
    _: 1
  }, 8, ["value", "disabled", "options"]))
}
}

})